import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getAmpConfigFlags } from 'shared/config/amp-config';
import { AuthService } from 'shared/lib/keycloak';

export const useAmpNavV2 = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const { isNewNavigationEnabled } = getAmpConfigFlags();

    // @TODO: stop checking isNewNavigationEnabled after RFS 2025 (new nav release)
    if (isNewNavigationEnabled && window.AmpNavigationV2Module) {
      const { renderAmpNavV2 } = window.AmpNavigationV2Module;

      const kc = AuthService.getKC();
      renderAmpNavV2('amp-nav-v2-container', {
        _keycloak: kc,
        pageTitle: t('Home'),
        enableSalesforceChatSessionCleaning: true,
        apiData: {
          retail: {
            userPrograms: {
              // informs amp-nav-v2 that user assets will be passed through apiData
              isLoading: true,
            },
            userAssets: {
              // informs amp-nav-v2 that user assets will be passed through apiData
              isLoading: true,
            },
          },
          onboarding: {
            userInfo: {
              // informs amp-nav-v2 that user assets will be passed through apiData
              isLoading: true,
            },
          },
          aquaApi: {
            userLicenses: {
              // informs amp-nav-v2 that user assets will be passed through apiData
              isLoading: true,
            },
          },
        },
      });
    }
  }, [t]);
};
